module.exports = __webpack_public_path__ + "static/media/paper-roll.ea1b6831.png";